module.exports = __webpack_public_path__ + "static/img/NANYAlogo_2.e818ee7f.svg";